import { inject, Injectable } from '@angular/core';
import { AxiosHttpService } from './axios-http.service';
import {
  SavePhoneRequest,
  SavePhoneResponse,
} from '../interfaces/dialogs/save-phone-dialog.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 會員中心保存電話號碼dialog service
 */
@Injectable({
  providedIn: 'root',
})
export class SavePhoneDialogService {
  axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   * 驗證 OTP 及儲存手機
   * @param request 儲存手機號碼請求參數
   */
  savePhone(
    request: SavePhoneRequest
  ): Observable<ApiResponse<SavePhoneResponse>> {
    return this.http.patch<ApiResponse<SavePhoneResponse>>(
      API_ENDPOINTS.SAVE_PHONE,
      request
    );
  }
}
